// components/Survey.tsx
import "survey-core/survey-core.css";
import { Survey } from "survey-react-ui";
import { Model } from "survey-core";
import "survey-core/i18n/russian";
import { useEffect } from "react";
import DataUserLoyalty from "../store/DataUserLoyalty.js";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import acceptDataToServer from "../service/Service.js";

const SurveyComp = observer(() => {
    const navigate = useNavigate();

    useEffect(() => {
        // console.log(DataUserLoyalty.userName);

        if (
            DataUserLoyalty.userName == "" &&
            DataUserLoyalty.userPhone == "" &&
            DataUserLoyalty.userSurname == ""
        ) {
            navigate("/happyCitizen/registration");
        }
    }, []);
    const surveyJson = {
        showProgressBar: true,
        progressBarLocation: "top",
        pageNextText: "Далее",
        pagePrevText: "Назад",
        completeText: "Отправить ",
        page: "hello",

        pages: [
            {
                elements: [
                    {
                        name: "Укажите ваш возраст",
                        title: "Укажите ваш возраст",
                        type: "radiogroup",
                        choices: [
                            { value: 5, text: "До 18 лет " },
                            { value: 4, text: "18–25 лет " },
                            { value: 3, text: "26–35 лет " },
                            { value: 2, text: "36–45 лет " },
                            { value: 1, text: "46–60 лет " },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Где вы проживаете? ",
                        title: "Где вы проживаете? ",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Город (крупный мегаполис, население более 1 млн человек) ",
                            },
                            {
                                value: 4,
                                text: "Город (население от 100 тыс. до 1 млн человек) ",
                            },
                            {
                                value: 3,
                                text: "Малый город (население менее 100 тыс. человек)  ",
                            },
                            { value: 2, text: "Посёлок городского типа " },
                            { value: 1, text: "Село или деревня " },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Название города или населенного пункта, в котором Вы проживаете",
                        title: "Название города или населенного пункта, в котором Вы проживаете",
                        type: "text",
                        isRequired: true,
                    },
                    {
                        name: "Ваше образование",
                        title: "Ваше образование",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Город (крупный мегаполис, население более 1 млн человек) ",
                            },
                            {
                                value: 4,
                                text: "Город (население от 100 тыс. до 1 млн человек) ",
                            },
                            {
                                value: 3,
                                text: "Малый город (население менее 100 тыс. человек)  ",
                            },
                            { value: 2, text: "Посёлок городского типа " },
                            { value: 1, text: "Школьное" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Чувствуете ли вы себя в безопасности в своем районе в вечернее время?",
                        title: "Чувствуете ли вы себя в безопасности в своем районе в вечернее время?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Да, всегда",
                            },
                            {
                                value: 4,
                                text: "Чаще да, чем нет ",
                            },
                            {
                                value: 3,
                                text: "Иногда",
                            },
                            { value: 2, text: "Редко " },
                            { value: 1, text: "Никогда" },
                        ],
                        isRequired: true,
                    },
                ],
            },
            {
                elements: [
                    {
                        name: "Насколько доступно для вас экстренное медицинское обслуживание (например, скорая помощь)?",
                        title: "Насколько доступно для вас экстренное медицинское обслуживание (например, скорая помощь)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень доступно",
                            },
                            {
                                value: 4,
                                text: "Доступно ",
                            },
                            {
                                value: 3,
                                text: "Средне",
                            },
                            { value: 2, text: "Труднодоступно " },
                            { value: 1, text: "Очень труднодоступно" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Насколько доступно для вас жилье по цене в вашем городе?",
                        title: "Насколько доступно для вас жилье по цене в вашем городе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень доступно",
                            },
                            {
                                value: 4,
                                text: "Доступно ",
                            },
                            {
                                value: 3,
                                text: "Средне",
                            },
                            { value: 2, text: "Труднодоступно " },
                            { value: 1, text: "Очень труднодоступно" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Легко ли вам найти работу с достойной оплатой в вашем городе?",
                        title: "Легко ли вам найти работу с достойной оплатой в вашем городе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень легко",
                            },
                            {
                                value: 4,
                                text: "Легко ",
                            },
                            {
                                value: 3,
                                text: "Средне",
                            },
                            { value: 2, text: "Трудно " },
                            { value: 1, text: "Очень трудно" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Удовлетворены ли вы возможностями для физической активности (велодорожки, спортзалы, бассейны)?",
                        title: "Удовлетворены ли вы возможностями для физической активности (велодорожки, спортзалы, бассейны)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень удовлетворен",
                            },
                            {
                                value: 4,
                                text: "Удовлетворен ",
                            },
                            {
                                value: 3,
                                text: "Ни удовлетворен, ни нет",
                            },
                            { value: 2, text: "Неудовлетворен " },
                            { value: 1, text: "Очень неудовлетворен" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Как вы оцениваете уровень доступа к чистой питьевой воде в вашем городе?",
                        title: "Как вы оцениваете уровень доступа к чистой питьевой воде в вашем городе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень высокий",
                            },
                            {
                                value: 4,
                                text: "Высокий ",
                            },
                            {
                                value: 3,
                                text: "Средний",
                            },
                            { value: 2, text: "Низкий " },
                            { value: 1, text: "Очень низкий" },
                        ],
                        isRequired: true,
                    },
                ],
            },
            {
                elements: [
                    {
                        name: "Насколько город стимулирует развитие малого и среднего бизнеса?",
                        title: "Насколько город стимулирует развитие малого и среднего бизнеса?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень Хорошо",
                            },
                            {
                                value: 4,
                                text: "Хорошо ",
                            },
                            {
                                value: 3,
                                text: "Средне",
                            },
                            { value: 2, text: "Плохо " },
                            { value: 1, text: "Очень плохо" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Удовлетворены ли вы количеством мест для проведения досуга (кафе, парки, кинотеатры)?",
                        title: "Удовлетворены ли вы количеством мест для проведения досуга (кафе, парки, кинотеатры)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень удовлетворен",
                            },
                            {
                                value: 4,
                                text: "Удовлетворен ",
                            },
                            {
                                value: 3,
                                text: "Ни удовлетворен, ни нет",
                            },
                            { value: 2, text: "Неудовлетворен " },
                            { value: 1, text: "Очень неудовлетворен" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Удовлетворены ли вы уровнем доступа к образовательным ресурсам (библиотеки, курсы, онлайн-платформы)?",
                        title: "Удовлетворены ли вы уровнем доступа к образовательным ресурсам (библиотеки, курсы, онлайн-платформы)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень удовлетворен",
                            },
                            {
                                value: 4,
                                text: "Удовлетворен ",
                            },
                            {
                                value: 3,
                                text: "Ни удовлетворен, ни нет",
                            },
                            { value: 2, text: "Неудовлетворен " },
                            { value: 1, text: "Очень неудовлетворен" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Насколько удобно вам добираться до ближайшего парка или лесопарковой зоны?",
                        title: "Насколько удобно вам добираться до ближайшего парка или лесопарковой зоны?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "В пешей доступности",
                            },
                            {
                                value: 4,
                                text: "На общественном транспорте ",
                            },
                            {
                                value: 3,
                                text: "На личном транспорте",
                            },
                            { value: 2, text: "Далеко и неудобно " },
                            { value: 1, text: "Нет доступа" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Насколько вы удовлетворены удобством использования общественного транспорта (автобусы, метро, трамваи)?",
                        title: "Насколько вы удовлетворены удобством использования общественного транспорта (автобусы, метро, трамваи)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень удовлетворен",
                            },
                            {
                                value: 4,
                                text: "Удовлетворен ",
                            },
                            {
                                value: 3,
                                text: "Ни удовлетворен, ни нет",
                            },
                            { value: 2, text: "Неудовлетворен " },
                            { value: 1, text: "Очень неудовлетворен" },
                        ],
                        isRequired: true,
                    },
                ],
            },
            {
                elements: [
                    {
                        name: "Как вы оцениваете качество дорожного покрытия для автомобилей в вашем городе?",
                        title: "Как вы оцениваете качество дорожного покрытия для автомобилей в вашем городе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень высокое",
                            },
                            {
                                value: 4,
                                text: "Высокое ",
                            },
                            {
                                value: 3,
                                text: "Среднее",
                            },
                            { value: 2, text: "Низкое " },
                            { value: 1, text: "Очень низкое" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Как вы оцениваете общее качество воздуха в вашем городе?",
                        title: "Как вы оцениваете общее качество воздуха в вашем городе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень высокое (воздух чистый)",
                            },
                            {
                                value: 4,
                                text: "Высокое ",
                            },
                            {
                                value: 3,
                                text: "Среднее",
                            },
                            { value: 2, text: "Низкое " },
                            {
                                value: 1,
                                text: "Очень низкое (воздух загрязнен)",
                            },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Чувствуете ли вы влияние качества воздуха на свое здоровье (аллергия, болезни дыхательной системы)?",
                        title: "Чувствуете ли вы влияние качества воздуха на свое здоровье (аллергия, болезни дыхательной системы)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Нет, не замечаю влияния",
                            },
                            {
                                value: 4,
                                text: "Очень редко ",
                            },
                            {
                                value: 3,
                                text: "Иногда",
                            },
                            { value: 2, text: "Часто " },
                            {
                                value: 1,
                                text: "Постоянно",
                            },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Удовлетворены ли вы наличием зелёных зон, которые способствуют улучшению качества воздуха?",
                        title: "Удовлетворены ли вы наличием зелёных зон, которые способствуют улучшению качества воздуха?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Очень удовлетворен",
                            },
                            {
                                value: 4,
                                text: "Удовлетворен ",
                            },
                            {
                                value: 3,
                                text: "Ни удовлетворен, ни нет",
                            },
                            { value: 2, text: "Неудовлетворен " },
                            { value: 1, text: "Очень неудовлетворен" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Есть ли у вас доступ к информации о качестве воздуха в реальном времени (приложения, вебсайты)?",
                        title: "Есть ли у вас доступ к информации о качестве воздуха в реальном времени (приложения, вебсайты)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Да, всегда доступна",
                            },
                            {
                                value: 4,
                                text: "Да, но с ограничениями ",
                            },
                            {
                                value: 3,
                                text: "Иногда",
                            },
                            { value: 2, text: "Редко " },
                            { value: 1, text: "Нет вообще" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Как часто вы слышите или становитесь свидетелем преступлений в своём районе?",
                        title: "Как часто вы слышите или становитесь свидетелем преступлений в своём районе?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Никогда",
                            },
                            {
                                value: 4,
                                text: "Редко",
                            },
                            {
                                value: 3,
                                text: "Иногда",
                            },
                            { value: 2, text: "Часто " },
                            { value: 1, text: "Постоянно" },
                        ],
                        isRequired: true,
                    },
                    {
                        name: "Чувствуете ли вы себя защищённым от киберугроз (мошенничество, взломы)?",
                        title: "Чувствуете ли вы себя защищённым от киберугроз (мошенничество, взломы)?",
                        type: "radiogroup",
                        choices: [
                            {
                                value: 5,
                                text: "Да, полностью защищён",
                            },
                            {
                                value: 4,
                                text: "Скорее защищён",
                            },
                            {
                                value: 3,
                                text: "Ни защищён, ни нет",
                            },
                            { value: 2, text: "Скорее не защищён " },
                            { value: 1, text: "Совсем не защищён " },
                        ],
                        isRequired: true,
                    },
                ],
            },
        ],
    };

    const survey = new Model(surveyJson);
    survey.locale = "ru";

    survey.onComplete.add((survey, options) => {
        options.showSaveInProgress();
        const dataObj = survey.data;
        console.log(survey.data);

        const dataToFetch = {
            userName: DataUserLoyalty.userName,
            dataJson: dataObj,
        };
        const dataStr = JSON.stringify(dataToFetch);
        acceptDataToServer(dataStr, options);
    });
    return (
        <div className=' h-screen '>
            <Survey className=' ' model={survey} />
        </div>
    );
});

export default SurveyComp;
